import { Component, OnInit, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FaceSandbox } from '../../shared/sandbox/providers/face.sandbox';
import { FacePadComponent } from '@id3/face-pad';
import { GlobalSandbox } from '../../shared/sandbox/providers/global.sandbox';

@Component({
	selector: 'id3-biometrics',
	templateUrl: './biometrics.component.html',
	styleUrls: ['./biometrics.component.css'],
	providers: [FaceSandbox]
})
export class BiometricsComponent implements OnInit {
	constructor(public faceSandbox: FaceSandbox, public globalSandbox: GlobalSandbox) { }

	@ViewChild(FacePadComponent, { static: false })
	facePad: FacePadComponent;

	@Output() nextEvent = new EventEmitter<boolean>();
	@Output() previousEvent = new EventEmitter<boolean>();

	ngOnInit(): void {

		this.globalSandbox.isAccreditationUseCase().subscribe(
			(res) => {
				if (res) {
					this.faceSandbox.takePicture();
				}
			}
		);
		navigator.mediaDevices.ondevicechange = () => {
			if (this.faceSandbox.isFacePad) {
				this.faceSandbox.takePicture();
			}
		}

	}

	ngOnDestroy(): void {
		this.faceSandbox.clearFaceImageLoading();
		this.faceSandbox.clearMatchLoading();
		this.faceSandbox.setPadDisplay(false);
	}

	next(): void {
		this.nextEvent.emit();
	}

	previous(): void {
		this.previousEvent.emit();
	}
}
